import $ from 'jquery'

$(document).ready(function() {
	if ($('body').hasClass('home')) {
		$('.banner-slides').slick({
			arrows: false,
			dots: true,
			fade: true,
			autoplay: true,
			speed: 800,
			autoplaySpeed: 4000,
			pauseOnHover: false
		})

		//Scroll down button
		$('#scroll-down').on('click', function() {
			$('html,body').animate(
				{
					scrollTop: $('section.contact-strip').offset().top
				},
				800
			)
		})

		//Side Form
		const $sideForm = $('#form-module')
		$('#form-trigger').on('click', function(e) {
			e.preventDefault()
			$sideForm.toggleClass('expanded')
		})

		const screenHeight = $(window).height()
		$(window).on('scroll', function() {
			$sideForm.toggleClass('ready', $(window).scrollTop() > screenHeight / 2)
		})

		$('#close-side-form').on('click', function(e) {
			e.preventDefault()
			$('#form-module').removeClass('expanded')
		})
	}
})
